import { render, staticRenderFns } from "./InserirDocumentosMetaEntrega.vue?vue&type=template&id=23f6f4d2"
import script from "./InserirDocumentosMetaEntrega.vue?vue&type=script&lang=js"
export * from "./InserirDocumentosMetaEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports